import { render, staticRenderFns } from "./StarterNavbar.vue?vue&type=template&id=243f58f0&scoped=true"
import script from "./StarterNavbar.vue?vue&type=script&lang=js"
export * from "./StarterNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243f58f0",
  null
  
)

export default component.exports